import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Button, Collapse, Link } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { AppCardSection, AppDescriptionList } from '@shared';
import { buildDescriptionListItems } from 'utils/index';

const propTypes = {
  customerTicket: PropTypes.object.isRequired,
}

const defaultProps = {

}

// relatedDeliveryRecord & Task
const CustomerDataSection = (props) => {
  const { customerTicket } = props;

  // This is the order the RMA came from, not the RMA being worked on - worth having at hand, but it
  // should not compete with the ticket's own data, so it starts collapsed.
  const [relatedRecordOpen, setRelatedRecordOpen] = useState(false);

  const buildRelatedRecordItems = () => {
    if(!customerTicket.relatedDeliveryRecord){
      return [];
    }
    else if(customerTicket.relatedDeliveryRecord.__typename == 'Order'){
      return buildDescriptionListItems([
        { name: "relatedDeliveryRecord", title: "Ref", accessor: (relatedDeliveryRecord) => 
          <Link href={relatedDeliveryRecord.adminUrl} target="_blank" rel="noopener">
            { relatedDeliveryRecord.orderNumber }
          </Link>
        },
        { name: "relatedDeliveryRecord", title: I18n.t("activerecord.models.courier.one"), accessor: (relatedDeliveryRecord) => relatedDeliveryRecord.courier?.name },
        { name: "relatedDeliveryRecord", title: I18n.t("activerecord.models.team.one"), accessor: (relatedDeliveryRecord) => relatedDeliveryRecord.courier?.team?.name },
      ], customerTicket);
    }
    else if(customerTicket.relatedDeliveryRecord.__typename == 'DispatchOrder'){
      return buildDescriptionListItems([
        { name: "relatedDeliveryRecord", title: I18n.t("activerecord.models.dispatch_control.one"), accessor: (relatedDeliveryRecord) => relatedDeliveryRecord.dispatchControl.name },
        { name: "relatedDeliveryRecord", title: "#", accessor: (relatedDeliveryRecord) => relatedDeliveryRecord.orderNumber },
        { name: "relatedDeliveryRecord", title: I18n.t("activerecord.models.team.one"), accessor: (relatedDeliveryRecord) => relatedDeliveryRecord.dispatchControl.team.name },
      ], customerTicket);    
    }
    else{
      throw("Unrecognized related record type")
    }
  }

  const relatedRecordItems = buildRelatedRecordItems();

  const pickupPointItems = !customerTicket.pickupPoint ? [] : buildDescriptionListItems([
    { name: "pickupPoint", title: "Tienda", accessor: (pickupPoint) => pickupPoint.name },
    { name: "pickupPoint", title: I18n.t("activerecord.attributes.customer_ticket.address"), accessor: (pickupPoint) => pickupPoint.address, hideIf: (pickupPoint) => !pickupPoint.address },
    { name: "pickupPoint", title: "Horario", accessor: (pickupPoint) => pickupPoint.schedule, hideIf: (pickupPoint) => !pickupPoint.schedule },
  ], customerTicket);


  return (
    <>
      { !!customerTicket.relatedDeliveryRecord &&
        <AppCardSection>
          <Button
            variant="text"
            color="inherit"
            endIcon={ relatedRecordOpen ? <ExpandLessIcon /> : <ExpandMoreIcon /> }
            aria-expanded={relatedRecordOpen}
            aria-controls="related-record-details"
            onClick={() => setRelatedRecordOpen((open) => !open)}
          >
            Registro Asociado
          </Button>

          <Collapse in={relatedRecordOpen} id="related-record-details" unmountOnExit>
            <AppDescriptionList
              items={relatedRecordItems}
            />
          </Collapse>
        </AppCardSection>
      }

      { !!customerTicket.pickupPoint &&
        <AppCardSection title="Punto de Retiro">
          <AppDescriptionList
            items={pickupPointItems}
          />
        </AppCardSection>
      }
    </>
  )
};

CustomerDataSection.propTypes = propTypes;
CustomerDataSection.defaultProps = defaultProps;

export default CustomerDataSection;